import { computed, ref } from 'vue'

import {
  readAuthSession,
  subscribeAuthSession,
  writeAuthSession,
  type AuthSession,
} from '../../../shared/components/authSessionStore'

/** 与营销站共享的运行时单例 session。 */
const sessionRef = ref<AuthSession | null>(readAuthSession())
let subscribed = false

/**
 * 懒订阅浏览器端会话变化（仅客户端生效）。
 */
function ensureSubscribed(): void {
  if (subscribed) return
  if (globalThis.window === undefined) return
  subscribed = true
  subscribeAuthSession((next) => {
    sessionRef.value = next
  })
}

/**
 * 写入登录会话（同时持久化到 localStorage）。
 *
 * @param next - 登录成功后的会话
 */
function setSession(next: AuthSession): void {
  sessionRef.value = next
  writeAuthSession(next)
}

/**
 * 清空登录会话（同时清除 localStorage 持久化）。
 */
function clearSession(): void {
  sessionRef.value = null
  writeAuthSession(null)
}

/**
 * 维护编辑器侧登录态（与营销站同源共享）。
 */
export function useEditorAuth() {
  ensureSubscribed()
  const session = computed(() => sessionRef.value)
  const isLoggedIn = computed(() => Boolean(sessionRef.value?.token))
  const userEmail = computed(() => sessionRef.value?.email || '')

  return {
    session,
    isLoggedIn,
    userEmail,
    setSession,
    clearSession,
  }
}
